import { render, staticRenderFns } from "./EditThemeMenu.vue?vue&type=template&id=937f8724&"
import script from "./EditThemeMenu.vue?vue&type=script&lang=js&"
export * from "./EditThemeMenu.vue?vue&type=script&lang=js&"
import style0 from "./EditThemeMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "EditThemeMenu.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/menus/EditThemeMenu.vue
// module id = 2314
// module chunks = 1